import {
  RatingConfigurator,
  EmailConfigurator,
  CommentConfigurator,
  SingleSelectionConfigurator,
} from '@bingads-webui-campaign-react/survey-factory-tools';

export const BudgetCenterOverallSatisfactionSurveyConfig = (options) => {
  const { i18n } = options;

  return {
    featureArea: 'BudgetCenterOverallSatisfactionSurvey',
    style: {
      root: {
        minWidth: 600,
        maxWidth: 600,
      },
    },
    others: {
      shouldHideInputWhenNotSelected: true,
    },
    rating: {
      isRequired: true,
      Type: RatingConfigurator,
      key: 'rating',
      page: 0,
      position: 0,
      getTitle: () => i18n.getString(_TL_('How satisfied are you with Budget Center overall?')),
      isVisible: () => true,
      options: [
        {
          key: '5',
          text: i18n.getString(_TL_('Very satisfied')),
          rating: 1.0,
        },
        {
          key: '4',
          text: i18n.getString(_TL_('Moderately satisfied')),
          rating: 0.8,
        },
        {
          key: '3',
          text: i18n.getString(_TL_('Neutral')),
          rating: 0.6,
        },
        {
          key: '2',
          text: i18n.getString(_TL_('Moderately dissatisfied')),
          rating: 0.4,
        },
        {
          key: '1',
          text: i18n.getString(_TL_('Very dissatisfied')),
          rating: 0.2,
        },
      ],
    },
    questions: [
      {
        isRequired: true,
        Type: SingleSelectionConfigurator,
        key: 'q1',
        page: 1,
        position: 0,
        getTitle: () => i18n.getString(_TL_('What feature or aspect of Budget Center do you find the most valuable?')),
        isVisible: () => true,
        options: [
          {
            key: 'q1o1',
            text: i18n.getString(_TL_('Budget settings')),
          },
          {
            key: 'q1o2',
            text: i18n.getString(_TL_('Constraints and alerts')),
          },
          {
            key: 'q1o3',
            text: i18n.getString(_TL_('Budget changes and corresponding performance')),
          },
          {
            key: 'q1o4',
            text: i18n.getString(_TL_('Spending trend')),
          },
          {
            key: 'q1o5',
            text: i18n.getString(_TL_('Recommendations')),
          },
          {
            key: 'q1o6',
            text: i18n.getString(_TL_('Others - please specify')),
            placeholder: i18n.getString(_TL_('Please feel free to elaborate')),
            hasInput: true,
            maxLength: 1024,
          },
        ],
        data: {
        },
      },
      {
        isRequired: false,
        Type: CommentConfigurator,
        key: 'q2',
        page: 2,
        position: 0,
        getTitle: () => i18n.getString(_TL_('Do you have any suggestions for improving Budget Center?')),
        isVisible: () => true,
        maxLength: 1024,
        data: {
        },
      },
    ],
    email: {
      isRequired: true,
      Type: EmailConfigurator,
      key: 'email',
      page: 2,
      position: 1,
      getTitle: () => i18n.getString(_TL_('Can we follow up with you about your responses?')),
      isVisible: () => true,
      options: [
        {
          key: 'yes',
          text: i18n.getString(_TL_('Yes - specify the contact email below')),
          placeholder: i18n.getString(_TL_('Enter your email')),
          hasInput: true,
        },
        {
          key: 'no',
          text: i18n.getString(_TL_('No')),
        },
      ],
    },
  };
};
